"use strict";
/**
 * OpenSearch Pattern Search Types
 *
 * These types represent the structure of pattern documents in OpenSearch indices.
 * They match the output of filterPatternForIndex from lambda-utilities
 */
Object.defineProperty(exports, "__esModule", { value: true });
